import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DiscountType, ModalDialogType, OrderConditions, OrderStatus, OrderType, ServiceType, UserAndSellerShowMode } from 'src/app/@core/constants';
import { PosAddEditProductReturnManualModalService } from 'src/app/@core/services/pos-add-edit-product-return-manual-modal.service';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosCustomerTableModalService } from 'src/app/@core/services/pos-customer-table-modal.service';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { PosUserAndSellerListModalService } from 'src/app/@core/services/pos-user-and-seller-list-modal.service';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { CancellationReason } from 'src/app/models/cancellation-reason';
import { ColumnTable } from 'src/app/models/column-table';
import { Discount } from 'src/app/models/discount';
import { ExonerationReason } from 'src/app/models/exoneration-reason';
import { InvoiceManual } from 'src/app/models/invoice-manual';
import { InvoiceManualLine } from 'src/app/models/invoice-manual-line';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { OrderRequest } from 'src/app/models/requests/order-request';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { Tax } from 'src/app/models/tax';
import { TaxExemption } from 'src/app/models/tax-exemption';
import { AuthService } from 'src/app/services/auth.service';
import { CancellationReasonService } from 'src/app/services/cancellation-reason.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EquipmentRegistrationService } from 'src/app/services/equipment-registration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ExonerationReasonService } from 'src/app/services/exoneration-reason.service';
import { InvoicesManualService } from 'src/app/services/invoices-manual.service';
import { OrderService } from 'src/app/services/order.service';
import { ProductsService } from 'src/app/services/products.service';
import { TaxesService } from 'src/app/services/taxes.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-return-order-manual',
  templateUrl: './create-return-order-manual.component.html',
  styleUrls: ['./create-return-order-manual.component.sass']
})
export class CreateReturnOrderManualComponent implements OnInit {

  isLoaded: boolean = false;
  invoiceCode: string = "";

  invoice: InvoiceManual = new InvoiceManual();
  customer: CustomerTableModel = new CustomerTableModel();
  customerInformation: string = "SELECCIONAR CLIENTE";
  seller: CustomerTableModel = new CustomerTableModel();
  sellerInformation: string = "SELECCIONAR VENDEDOR";
  productsCart: Paging<Array<ProductCart>> = new Paging([]);
  cancellationReasons: Array<CancellationReason> = [];
  cancellationReasonSelected: CancellationReason = new CancellationReason();
  observationResult: string = "";
  conditions: Array<{ code: string, description: string }> = [{ code: "contado", description: "Contado" },
  { code: "credito", description: "Credito" }];
  conditionSelected: { code: string, description: string } = { code: "", description: '' };
  exoneratedReasons: Array<ExonerationReason> = [];
  exoneratedReasonSelected: ExonerationReason = new ExonerationReason();
  invoiceDateSelected: Date = new Date();
  contractNumber: string = '';
  taxes: Tax[] = [];
  constructor(private posObservationsService: PosOrderObservationsService, private invoiceService: InvoicesManualService, private orderService: OrderService, private cancellationReasonService: CancellationReasonService, private taxesService: TaxesService, private configService: ConfigurationService, private authService: AuthService, private router: Router, private confirmService: PosConfirmationService, private equipmentRegistrationService: EquipmentRegistrationService, private productService: ProductsService, private exonerationReasonService: ExonerationReasonService, private posCustomerModalService: PosCustomerTableModalService, private posSellerModalService: PosUserAndSellerListModalService, private productModalService: PosAddEditProductReturnManualModalService, private readonly exceptionSolutionService: ExceptionSolutionService) { }

  async ngOnInit(): Promise<void> {
    this.cancellationReasons = (await this.cancellationReasonService.readCancellationReasons().toPromise()).response.content;
    this.exoneratedReasons = (await this.exonerationReasonService.readExonerations().toPromise()).response.content;
    this.taxes = (await this.taxesService.readTaxes().toPromise()).response.content;
  }

  async create() {

    let confirmResult = await this.confirmService.showAsync("Creación de Orden",
      "¿Esta seguro de querer crear esta orden para Devolución?", ModalDialogType.SUCCESS);

    if (!confirmResult || !await this.createValidations()) {
      return;
    }
    let orderRequest: OrderRequest = new OrderRequest();
    let taxExemption = new TaxExemption();

    if (this.exoneratedReasonSelected?.reason) {
      taxExemption.reason = this.exoneratedReasonSelected;
    }
    orderRequest = orderRequest.buildOrderRequest(this.productsCart.content.filter(f => f.inputMarkForReturn),
      this.taxes,
      this.customer, this.seller,
      this.configService.readSelectedBranchAndSalesOrg().branch.code, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code,
      taxExemption, new Discount(), [], "",
      this.observationResult, OrderType.RETURN, OrderStatus.INITIAL,
      this.conditionSelected.code == "credito" ? OrderConditions.FINAL_CUSTOMER_CREDIT : undefined,
      undefined, undefined, undefined, undefined, undefined, this.cancellationReasonSelected.code);

    orderRequest.invoiceNumber = this.invoiceCode;
    orderRequest.originalExternalInvoices = this.invoiceCode;
    orderRequest.originalInvoiceDate = new Date(this.invoice.date);
    orderRequest.contractNumber = this.contractNumber;
    orderRequest.printingAuthorizationKey = this.invoice.cai;
    let result = (await this.orderService.createOrder(orderRequest, false).toPromise()).response;

    if (result?.code) {
      Swal.fire({
        title: `Devolución`,
        html: `Orden de Devolución ${result.code} se ha creado con éxito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
      this.router.navigate(["returnInvoices", result.code]);
    }
  }

  async createValidations() {

    if (this.productsCart.content.every(f => !f.inputMarkForReturn)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `No se han escogido productos para devolver.`);
      return false;
    }
    if (this.productsCart.content.some(f => f.inputMarkForReturn && f.inputReturnedAmount == 0)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `No se han escogido productos para devolver.`);
      return false;
    }
    if (!this.cancellationReasonSelected?.code) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `Tiene que escoger una Motivo de Devolución`);
      return false;
    }
    if (! await this.extraWarrantyValidations()) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `No se puede devolver este producto sin devolver la extragarantia primero.`);
      return false;
    }
    if (!this.seller?.code) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `Tiene que escoger un vendedor.`);
      return false;
    }
    if (this.conditionSelected.code == "credito" && !this.contractNumber) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `Ingrese un código de contrato.`);
      return false;
    }
    return true;
  }
  async extraWarrantyValidations() {
    let result = true;
    for (let entry of this.productsCart.content) {
      let product = (await this.productService.readProduct({ branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code, productCode: entry.productCode }).toPromise()).response;
      if (product.serviceType == ServiceType.EXTRA_WARRANTY && this.productsCart.content.some(p => p.code.toString() == entry?.code.toString() && !p.inputMarkForReturn)) {
        result = false;
      };
    }
    return result;
  }

  async observations() {
    await this.posObservationsService.show(this.observationResult, (result: string) => {
      this.observationResult = result;
    });
  }

  async searchInvoice() {
    if (this.invoiceCode) {
      this.invoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 10, value: { invoiceNumber: this.invoiceCode, salesOrg: this.configService.readSelectedBranchAndSalesOrg().salesOrg.code } }).toPromise()).response.content[0] || new InvoiceManual();
      if (this.invoice.id) {
        this.isLoaded = true;
        this.conditionSelected = this.conditions.find(f => f.code == this.invoice.condition.toLowerCase())!;
        this.invoiceDateSelected = DateUtils.getDateFromString2(this.invoice.date);
        this.contractNumber = this.invoice.contractNumber;
        this.loadProductsCart(this.invoice.invoiceLines);
      }
      else {
        this.isLoaded = false;
        this.exceptionSolutionService.showAlertWithSolution(`Devolución de Factura MT ${this.invoice.invoiceNumber}`, `No existe código de fatura`);
      }

    }
  }

  clear() {
    this.isLoaded = false;
    this.invoiceCode = "";
    this.invoice = new InvoiceManual();
    this.productsCart = new Paging([]);
    this.customerInformation = "SELECCIONAR CLIENTE";
    this.sellerInformation = "SELECCIONAR VENDEDOR";
    this.invoiceDateSelected = new Date();

  }

  getProductCartHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("inputMarkForReturn", "#", {
        type: 'switch', editable: true, selectedAllSwitch: true,
        disableSwitchFn: (product: ProductCart) => {
          return product.returnedAmount == product.amount;
        },
        selectAllSwitchFn: (productsCart: Paging<ProductCart[]>, result: boolean) => {
          if (result) {
            productsCart.content.forEach(f => f.inputReturnedAmount = f.amount);
          }
          else {
            productsCart.content.forEach(f => f.inputReturnedAmount = 0);
          }
          this.productsCart = new Paging(productsCart.content);
        }
      }),
      new ColumnTable("amount", "#", { type: "number", iconClass: "fa fa-shopping-cart", isIcon: true }),
      new ColumnTable("returnedAmount", "Devuelto", { type: 'number' }),
      new ColumnTable("productCode", "Código", { isSmall: true }),
      new ColumnTable("description", "Descripción", { isSmall: true }),
      new ColumnTable("serial", "Serie", { type: "badge" }),
      new ColumnTable("total", "Precio + ISV", { type: "currency" }),
      new ColumnTable("discountTotal", "Descuento", { type: "currency" }),
      new ColumnTable("inputReturnedAmount", "Cant. Devolución", {
        type: "number",
        iconClass: 'fa fa-cart-arrow-down', isIcon: true, editable: true,
        disableSwitchFn: (product: ProductCart) => {
          return product.returnedAmount == product.amount;
        }
      }),
      new ColumnTable("code", "Opciones", {
        type: "action",
        actions: [
          {
            fn: async (product: ProductCart) => {
              await this.productModalService.show(product, true, (result: ProductCart) => {
                let filteredCart = this.productsCart.content.filter(f => f.code != result.code);
                filteredCart.push(result);
                filteredCart = filteredCart.sort((n1, n2) => n1.code - n2.code);

                this.productsCart = new Paging(filteredCart);
              });
            },
            icon: "fa fa-pencil",
            isDisabled: false,
            tooltip: "Editar Producto"
          },
          {
            fn: async (product: ProductCart) => {
              let confirmResult = await this.confirmService.showAsync("Eliminar Producto",
                "¿Esta seguro de querer eliminar este producto?", ModalDialogType.WARNING);

              if (confirmResult) {
                this.productsCart.content = this.productsCart.content.filter(f => f.code != product.code);
                this.productsCart = new Paging(this.productsCart.content);
              }
            },
            icon: "fa fa-trash",
            isDisabled: false,
            tooltip: "Eliminar Producto"
          }
        ]
      }),
      new ColumnTable("code", "#", { type: "hidden" }),
      new ColumnTable("discount", "#", { type: "hidden" }),
      new ColumnTable("discount2", "#", { type: "hidden" }),
      new ColumnTable("associatedOrderEntry", "#", { type: "hidden" }),
      new ColumnTable("isDelivery", "#", { type: "hidden" }),
      new ColumnTable("taxCode", "#", { type: "hidden" }),
      new ColumnTable("originalTaxCode", "#", { type: "hidden" }),
      new ColumnTable("tax", "#", { type: "hidden" }),

    ]
  }

  loadProductsCart(lines: Array<InvoiceManualLine>) {
    this.productsCart = new Paging(lines.map(o => {
      let result = new ProductCart();
      result.code = parseInt(o.line);
      result.productCode = o.productCode;
      result.description = o.productName;
      result.amount = o.quantity;
      result.returnedAmount = o.returnedQuantity;
      result.serial = o.serialNumber;
      result.total = o.price;
      result.discountTotal = o.discount;
      if (o.discount > 0) {
        result.discount.discountType = DiscountType.ABSOLUTE;
        result.discount.discountValue = o.discount;
        result.discount.promotionCode = "DEVOLUCIONMANUAL";
      }
      else {
        result.discount = new Discount();
      }
      result.taxTotal = 0;
      result.tax = 15;
      result.taxCode = "A3";
      result.originalTaxCode = "A3";
      result.total = o.price;
      result.associatedOrderEntry = "";
      result.isDelivery = false;
      result.features = {};

      return result;
    }))
  }

  async saveProductCart(table: Array<ProductCart>): Promise<void> {

    this.productsCart.content = table.filter(f => f.code != undefined);
    if (table.some(f => f.inputReturnedAmount > f.amount)) {
      table.forEach(f => {
        f.inputReturnedAmount = f.inputReturnedAmount > f.amount ? f.amount : f.inputReturnedAmount;
      })
      this.productsCart = new Paging(table);
    }
  }

  async handleSearchCustomerClick() {
    this.customer = await this.posCustomerModalService.show().content?.customerSelectedEvent.toPromise() ?? new CustomerTableModel();
    this.customerInformation = `[${this.customer.code}] - ${this.customer.fullName}`
  }

  async handleSearchSellerCLick() {
    this.seller = (await this.posSellerModalService.show(UserAndSellerShowMode.SELLERS, false) as CustomerTableModel)
    this.sellerInformation = `[${this.seller.code}] - ${this.seller.fullName}`
  }

  async addProduct() {
    await this.productModalService.show(new ProductCart(), false, (result: ProductCart) => {
      let maxNum = (this.productsCart.content.map(f => f.code).sort((a, b) => a - b).pop() ?? 0) + 1;

      result.code = maxNum;

      this.productsCart.content.push(result);
      this.productsCart = new Paging(this.productsCart.content);
    });
  }
}
